import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import '../style/FloatLogo.css';

class FloatLogo extends React.Component {
    static propTypes = {
        logoSrc: PropTypes.string
    }
    static defaultProps = {
        logoSrc: ''
    }

    render() {
        return (
            <div className="float-logo">
                <img src={this.props.logoSrc} />
            </div>
        );
    }
}

const selector = (state) => ({
});

export default connect(selector, {
})(FloatLogo);
